import * as React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const IconBurger = (props) => (
    <svg
        className='icon-burger'
        fill='none'
        height={23}
        viewBox='0 0 24 23'
        width={24}
        xmlns='http://www.w3.org/2000/svg'
        {...props}>
        <path
            d='M1 1.5H23'
            stroke='#0E0E0E'
            strokeLinecap='round'
            strokeWidth={2}/>
        <path
            d='M1 11.5H23'
            stroke='#0E0E0E'
            strokeLinecap='round'
            strokeWidth={2}/>
        <path
            d='M1 21.5H23'
            stroke='#0E0E0E'
            strokeLinecap='round'
            strokeWidth={2} />
    </svg>
);

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconBurger;
